package com.vamvisions.main.api

import kotlinx.serialization.Serializable

/**
 * Body of every error response. [code] is a stable UPPER_SNAKE_CASE value that clients branch on,
 * [message] is a human-readable explanation that is safe to show.
 */
@Serializable
data class ApiError(
    val code: String,
    val message: String,
)
